import { formatAmount } from '../../../../../utils/format';
import BasketList from '../basket-list/BasketList';
import BasketListItem from '../basket-list/basket-list-item/BasketListItem';
import './simple-total.scss';
import type { SelectableItem } from '~/models/CampaignModel';
import { getOfferPeriods, getSummary, hasPremiums } from '~/store/basket/basket.helpers';

const SimpleTotal = ({ selectedProducts }: { selectedProducts: SelectableItem[] }) => {
  const summary = getSummary(selectedProducts);
  const offerPeriods = getOfferPeriods(selectedProducts);
  const hasPremiumProducts = hasPremiums(selectedProducts);

  function getMonthIntervalName(index: number) {
    if (index === 0) {
      return `Per måned 1-${offerPeriods[index]}`;
    }
    if (offerPeriods[index] === undefined) {
      return `Per måned etter 12 måneder`;
    }
    return `Per måned ${offerPeriods[index - 1] + 1}-${offerPeriods[index]}`;
  }

  return (
    <div className="simple-total">
      <BasketList>
        {summary.costIntervals.map((interval, index) => (
          <BasketListItem
            key={`Betala ${interval},-`}
            isTotal={true}
            name={getMonthIntervalName(index)}
            priceLabel={formatAmount(interval)}
            id={`Betala ${interval},-`}
          />
        ))}

        {summary.costNonRecurring !== 0 && (
          <BasketListItem
            isTotal={true}
            name="Engangskostnad utstyr (Første faktura)"
            priceLabel={formatAmount(summary.costNonRecurring)}
            id={'costNonRecurring'}
          />
        )}

        <div className="total-price">
          <BasketListItem
            isTotal={true}
            name="Totalt for første år"
            priceLabel={formatAmount(summary.costFirstYear)}
            id={'costFirstYear'}
          />
        </div>
        {hasPremiumProducts && (
          <p className="metadata">Prisen for første år inkluderer 12 mnd med tilleggspakker. Disse kan du avbestille når som helst.</p>
        )}
      </BasketList>
    </div>
  );
};

export default SimpleTotal;
